import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import { useNavigate } from "react-router-dom";
import { useEmployment } from "app/hooks/employment/useEmployment";
import { EMPLOYMENT } from "app/constants/apiEndPoints";
import { useDispatch } from "react-redux";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/employmentDetails";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import { employmentDetailsFromThree } from "app/utils/types";
import DynamicPreviousEmployer from "./dynamicForms/DynamicPreviousEmployer";
import { handleApiError } from "app/utils/handleApiError";

const PreviousEmployerDetails: React.FC = () => {
  const navigate = useNavigate();
  const { mutate: submitEmployment, isPending } = useEmployment();
  const dispatch = useDispatch();
  const { formThree, ...others } = useSelector(
    (state: RootState) => state.employmentDetails.stepsData
  );
  const savedIds = useSelector(
    (state: RootState) => state.loanTypesSteps.savedIds
  );
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    register,
    getValues,
    clearErrors,
    watch,
  } = useForm<employmentDetailsFromThree>({
    defaultValues: {
      secondjob: "no",
    },
  });

  const onSubmit = (data: employmentDetailsFromThree) => {
    const { secondjob } = data;
    const APiformateData: Partial<any> = {
      ...others?.formTwo,
      joiningDate: others?.formTwo?.joiningDate,
      employerName: others?.formOne?.employerName ?? "",
      previousEmployer: {
        ...data,
        startDate: data?.startDate,
        endDate: data?.endDate,
      },
    };

    const formateData = {
      ...data,
      startDate: data?.startDate,
      endDate: data?.endDate,
    };

    dispatch(
      addStepsData({
        ...others,
        formThree: formateData,
      })
    );
    if (secondjob === "no") {
      if ("secondjob" in APiformateData.previousEmployer) {
        delete APiformateData.previousEmployer.secondjob;
      }
      if ("previousemployer" in APiformateData) {
        delete APiformateData.previousemployer;
      }
      if ("hassecondjob" in APiformateData) {
        delete APiformateData.hassecondjob;
      }
      submitEmployment(
        {
          url: `${EMPLOYMENT}/${savedIds?.employmentID}/second`,
          data: APiformateData,
        },
        {
          onSuccess: () => {
            navigate(`/income-details`);
          },
          onError: (error: any) => {
            handleApiError(error);
          },
        }
      );
    } else {
      dispatch(nextStep());
    }
  };
  useEffect(() => {
    if (formThree) {
      reset(formThree);
    }
  }, [formThree, reset]);

  return (
    <>
      <ProgressBar progress={50} MB={7} />
      <div className="w-full  sm:w-[70%] xl:w-[45%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Previous Employer Details" />
        <form onSubmit={handleSubmit(onSubmit)} className="mt-6">
          <DynamicPreviousEmployer
            control={control}
            errors={errors}
            register={register}
            setValue={setValue}
            setError={setError}
            clearErrors={clearErrors}
            jobTitle="jobTitle"
            employerName="employerName"
            startDate="startDate"
            startDateValue={watch("startDate")}
            secondjob="secondjob"
            addressStreetName="street"
            addressStateName="state"
            addressPostCodeName="postCode"
            endDate="endDate"
            getValues={getValues}
          />

          <div className="flex justify-between my-10">
            <PreviousButtom
              onClick={() => {
                dispatch(prevStep());
              }}
            >
              Previous
            </PreviousButtom>
            <ContinueButton type="submit" loading={isPending}>
              Next
            </ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PreviousEmployerDetails;
